// extracted by mini-css-extract-plugin
export default {"wrapper":"ColumnsSettings_wrapper__FnEBG","checkboxWrapper":"ColumnsSettings_checkboxWrapper__MF891"};